<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-toolbar class="mb-2 pa-0" color="primary" dark flat>
          <v-toolbar-title>{{ grafTitle }}</v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="2">
        <v-autocomplete
          label="Lokalita"
          v-model="filterLokalitaId"
          :items="lokality"
          item-text="Name"
          item-value="ID"
          ref="acLokalita"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          label="Bod"
          v-model="filterBodId"
          :items="body"
          item-text="ZNMB"
          item-value="ID"
          ref="acBod"
          clearable
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.ZNMB }} - {{ item.IDMB }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <b>Dátum od:</b> {{ item.DatumOdString }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <b>Dátum do:</b> {{ item.DatumDoString }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <date-picker
          v-model="filterDatumOd"
          label="Dátum od"
          name="filterDatumOd"
        ></date-picker>
      </v-col>
      <v-col cols="2">
        <date-picker
          v-model="filterDatumDo"
          label="Dátum do"
          name="filterDatumDo"
        ></date-picker>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="filterHlbka"
          label="Hĺbka"
          name="filterHlbky"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-btn @click="show()" :loading="loading" :disabled="loading"
          >Zobraziť grafy</v-btn
        >
      </v-col>
    </v-row>
    <v-row v-if="grafData0.length > 0">
      <v-col cols="12" class="text-center text-h5">{{ grafSubtitle }}</v-col>
    </v-row>
    <v-row>
      <v-col cols="4" v-if="grafData0.length > 0">
        <line-chart
          :chart-data="grafValues(0)"
          :options="grafOptions(0)"
          style="xborder: solid 3px red; display: inline-block"
        ></line-chart>
      </v-col>
      <v-col cols="4" v-if="grafData1.length > 0">
        <horizontal-bar-chart
          :chart-data="grafValues(1)"
          :options="grafOptions(1)"
          style="xborder: solid 3px green; display: inline-block"
        ></horizontal-bar-chart>
      </v-col>
      <v-col cols="4" v-if="grafData2.length > 0">
        <line-chart
          :chart-data="grafValues(2)"
          :options="grafOptions(2)"
          style="
            xborder: solid 3px blue;
            xdisplay: inline-block;
            xtransform: rotate(90deg);
          "
        ></line-chart>
      </v-col>
      <v-col cols="4" v-if="grafData3.length > 0">
        <line-chart
          :chart-data="grafValues(3)"
          :options="grafOptions(3)"
        ></line-chart>
      </v-col>
      <v-col cols="4" v-if="grafData4.length > 0">
        <bar-chart
          :chart-data="grafValues(4)"
          :options="grafOptions(4)"
        ></bar-chart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//import * as moment from "moment"
import * as Miscella from "../plugins/miscella.js"
//import * as Colors from "../plugins/colors.js"
import DatePicker from "../components/DatePicker.vue"
import BarChart from "../components/charts/BarChart.js"
import HorizontalBarChart from "../components/charts/HorizontalBarChart.js"
import LineChart from "../components/charts/LineChart.js"

export default {
  data: function() {
    return {
      loading: false,
      filterLokalitaId: "",
      filterBodId: "",
      filterDatumOd: "",
      filterDatumDo: "",
      filterHlbka: 0,
      grafData0: [],
      grafData1: [],
      grafData2: [],
      grafData3: [],
      grafData4: [],
      lokality: [],
      body: []
    }
  },
  components: { DatePicker, BarChart, HorizontalBarChart, LineChart },
  props: {},
  computed: {
    grafTitle: function() {
      return "Grafy - Pohybová aktivita vrtu/hĺbky"
    },
    grafSubtitle: function() {
      return `Priebeh deformácie vrtu ${this.lokalitaName} - ${
        this.bodName
      } za obdobie ${Miscella.formatDatumEx(
        this.filterDatumOd,
        "DD.MM.YYYY"
      )} - ${Miscella.formatDatumEx(this.filterDatumDo, "DD.MM.YYYY")}`
    },
    lokalitaName: function() {
      let ret = ""
      try {
        if (this.$refs.acLokalita) {
          ret = this.$refs.acLokalita.selectedItems[0].Name
        }
      } catch (error) {
        console.log("lokalitaName", error)
      }
      return ret
    },
    bodName: function() {
      let ret = ""
      try {
        if (this.$refs.acBod) {
          ret = this.$refs.acBod.selectedItems[0].ZNMB
        }
      } catch (error) {
        console.log("bodName", error)
      }
      return ret
    },
    grafData3Max: function() {
      let myMax = 0
      //najdi abs.max. hodnotu
      for (let i = 0; i < this.grafData3.length; i++) {
        const data = this.grafData3[i]
        myMax = Math.max(myMax, Math.abs(data.OsaX))
        myMax = Math.max(myMax, Math.abs(data.OsaY))
      }
      //zaokruhli na najblizsie vyssie cislo - 100, 1000
      let n0 = Math.floor(Math.log10(myMax))
      let n10 = Math.pow(10, n0)
      let ret = Math.floor((myMax + n10) / n10) * n10
      return ret
    }
  },
  watch: {
    filterLokalitaId: {
      immediate: true,
      handler: function() {
        this.filterBodId = ""
        this.readBody()
      }
    }
  },
  methods: {
    readLokality: async function() {
      try {
        this.lokality = []
        let response = await this.$axios.get("/r/lokality/mer_inkp")
        if (response.status === 200) {
          this.lokality = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readBody: async function() {
      try {
        this.body = []
        if (
          Miscella.isSet(this.filterLokalitaId) &&
          this.filterLokalitaId !== ""
        ) {
          let response = await this.$axios.get(
            "/r/body/" + this.filterLokalitaId + "/mer_inkp"
          )
          if (response.status === 200) {
            let body = response.data
            for (let i = 0; i < body.length; i++) {
              let bod = body[i]
              bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
              bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
              bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
              bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
            }
            this.body = body
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    grafValues: function(aIndex) {
      let ret = ""
      switch (aIndex) {
        case 0:
          ret = {
            datasets: [
              {
                data: this.grafData0.map(function(i) {
                  return { x: i.Posun, y: i.Hlbka }
                }),
                borderColor: "#00bfff",
                pointRadius: "1",
                borderWidth: "1",
                pointStyle: "circle",
                fill: "false",
                type: "line"
              }
            ]
          }
          break
        case 1:
          ret = {
            labels: this.grafData1.map(function(i) {
              return i.Hlbka
            }),
            datasets: [
              {
                backgroundColor: "#3333FF",
                borderColor: "black",
                borderWidth: 0,
                barThickness: 16,
                maxBarThickness: 16,
                data: this.grafData1.map(function(i) {
                  return [i.AzimutOd, i.AzimutDo]
                })
              }
            ]
          }
          break
        case 2:
          ret = {
            labels: this.grafData2.map(i => i.Hlbka),
            datasets: [
              {
                data: this.grafData2.map(i => i.AzimutOd),
                borderColor: "#00bfff",
                pointRadius: "1",
                borderWidth: "1",
                pointStyle: "circle",
                fill: "+1",
                type: "line"
              },
              {
                data: this.grafData2.map(i => i.AzimutDo),
                borderColor: "#00bfff",
                pointRadius: "1",
                borderWidth: "1",
                pointStyle: "circle",
                fill: false,
                type: "line"
              }
            ]
          }
          break
        case 3:
          ret = {
            datasets: [
              {
                data: this.grafData3.map(function(i) {
                  return { x: i.OsaX, y: i.OsaY }
                }),
                borderColor: "#00bfff",
                pointRadius: "1",
                borderWidth: "1",
                lineTension: 0,
                pointStyle: "circle",
                fill: "false",
                type: "line"
              }
            ]
          }
          break
        case 4:
          ret = {
            labels: this.grafData4.map(i => i.Datum),
            datasets: [
              {
                backgroundColor: "blue",
                borderWidth: 1,
                barThickness: 6,
                maxBarThickness: 8,
                data: this.grafData4.map(i => i.Hodnota)
              }
            ]
          }
          break
        default:
          break
      }
      return ret
    },
    grafOptions: function(aIndex) {
      let ret = ""
      switch (aIndex) {
        case 0:
          ret = {
            maintainAspectRatio: false,
            responsive: false,
            legend: {
              display: false
            },
            title: {
              display: false
            },
            scales: {
              xAxes: [
                {
                  type: "linear",
                  position: "top",
                  ticks: {
                    beginAtZero: true
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Posun [mm]"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear",
                  position: "left",
                  ticks: {
                    beginAtZero: true,
                    reverse: true,
                    min: 0,
                    maxTicksLimit: 10,
                    stepSize: 3
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Hĺbka [m]"
                  }
                }
              ]
            }
          }
          break
        case 1:
          ret = {
            maintainAspectRatio: false,
            responsive: false,
            legend: { display: false },
            scales: {
              xAxes: [
                {
                  position: "top",
                  min: 0,
                  max: 360,
                  ticks: {
                    stepSize: 90
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Azimut [°]"
                  }
                }
              ],
              yAxes: [
                {
                  position: "left",
                  ticks: {
                    beginAtZero: true,
                    //reverse: true,
                    maxTicksLimit: 10,
                    min: 0,
                    stepSize: 3
                  },
                  scaleLabel: {
                    display: false,
                    labelString: "Hĺbka [m] xxx"
                  }
                }
              ]
            }
          }
          break
        case 2:
          ret = {
            maintainAspectRatio: false,
            responsive: false,
            legend: { display: false },
            scales: {
              xAxes: [
                {
                  position: "left",
                  ticks: {
                    beginAtZero: true,
                    //reverse: true,
                    min: 0,
                    stepSize: 3
                  },
                  scaleLabel: {
                    display: false,
                    labelString: "Hĺbka [m]"
                  }
                }
              ],
              yAxes: [
                {
                  position: "top",
                  min: 0,
                  max: 360,
                  ticks: {
                    stepSize: 90
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Azimut [°]"
                  }
                }
              ]
            }
          }
          break
        case 3:
          ret = {
            maintainAspectRatio: true,
            responsive: false,
            legend: {
              display: false
            },
            title: {
              display: false
            },
            scales: {
              xAxes: [
                {
                  type: "linear",
                  ticks: {
                    beginAtZero: true,
                    min: this.grafData3Max * -1,
                    max: this.grafData3Max
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "[mm]"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear",
                  ticks: {
                    beginAtZero: true,
                    min: this.grafData3Max * -1,
                    max: this.grafData3Max
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "[mm]"
                  }
                }
              ]
            }
          }
          break
        case 4:
          ret = {
            maintainAspectRatio: false,
            responsive: false,
            legend: {
              display: false
            },
            title: {
              display: false
            },
            scales: {
              xAxes: [
                {
                  type: "time",
                  time: {
                    unit: "year"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear",
                  scaleLabel: {
                    display: true,
                    labelString: "[mm]"
                  }
                }
              ]
            }
          }
          break
        default:
          break
      }
      return ret
    },
    urlFetch: function() {
      let url = "/r/chart/ink"
      url += "?bodID=" + Miscella.normalizeString(this.filterBodId)
      url +=
        "&datumOd=" + Miscella.formatDatumEx(this.filterDatumOd, "YYYY-MM-DD")
      url +=
        "&datumDo=" + Miscella.formatDatumEx(this.filterDatumDo, "YYYY-MM-DD")
      url += "&hlbka=" + this.filterHlbka
      return url
    },
    show: async function() {
      this.grafData0 = []
      this.grafData1 = []
      this.grafData2 = []
      this.grafData3 = []
      this.grafData4 = []
      try {
        console.log("show")
        this.loading = true
        let response = await this.$axios.get(this.urlFetch())
        if (response.status === 200) {
          if (response.data !== null) {
            this.grafData0 = response.data.data0
            this.grafData1 = response.data.data1
            this.grafData2 = response.data.data2
            this.grafData3 = response.data.data3
            this.grafData4 = response.data.data4
            if (this.grafData0 === null) {
              this.grafData0 = []
            }
            if (this.grafData1 === null) {
              this.grafData1 = []
            }
            if (this.grafData2 === null) {
              this.grafData2 = []
            }
            if (this.grafData3 === null) {
              this.grafData3 = []
            }
            if (this.grafData4 === null) {
              this.grafData4 = []
            }
          }
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    }
  },
  mounted: async function() {
    await this.$store.dispatch("fetchme", this.$axios)
    this.readLokality()
  }
}

/*
//Download Chart Image
document.getElementById("download").addEventListener('click', function(){
  var url_base64jp = document.getElementById("lineChart").toDataURL("image/jpg");
  var a =  document.getElementById("download");
  a.href = url_base64jp;
});
*/
</script>
